import React, { useEffect, useState, useRef} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import {useSxStyles as sx} from "../styles/sxStyles";


const Popup = (props) => {
    const open = props.open;
    const setDone = props.setDone;
    const component = props.component;
    const maxWidth = props.maxWidth;


    return (
        <>
            <Dialog
                open={open}
                maxWidth={maxWidth ? maxWidth : 'md'}
                fullWidth
                sx={sx.dialog}
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogContent dividers>
                    <DialogContentText>
                        {component}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {setDone(true)}} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default Popup;